var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { createSelector } from '@ngrx/store';
import { getEdit } from '../selectors';
var SET_SELECTED_TAB = '[edit ui] Set Selected Tab';
var VALIDATE_ERRORS = '[edit ui] Validate Errors';
var initState = {
    selectedTab: 0,
    showErrors: false,
};
export function editUiReducer(state, action) {
    if (state === void 0) { state = initState; }
    switch (action.type) {
        case SET_SELECTED_TAB:
            return __assign({}, state, { selectedTab: action.payload });
        case VALIDATE_ERRORS:
            return {
                selectedTab: action.payload,
                showErrors: true,
            };
        default:
            return state;
    }
}
var SetSelectedTabAction = /** @class */ (function () {
    function SetSelectedTabAction(payload) {
        this.payload = payload;
        this.type = SET_SELECTED_TAB;
    }
    return SetSelectedTabAction;
}());
export { SetSelectedTabAction };
var ValidateErrorsAction = /** @class */ (function () {
    function ValidateErrorsAction(payload) {
        this.payload = payload;
        this.type = VALIDATE_ERRORS;
    }
    return ValidateErrorsAction;
}());
export { ValidateErrorsAction };
export var getEditUi = createSelector(getEdit, function (state) { return state.editUi; });
export var getShowErrors = createSelector(getEditUi, function (state) { return state.showErrors; });
